export var headers;
(function (headers) {
    headers["correlationId"] = "x-correlation-uuid";
    headers["userAgent"] = "user-agent";
    headers["xForwardedFor"] = "x-forwarded-for";
    headers["xAmzRequestId"] = "x-amzn-requestid";
})(headers || (headers = {}));
